import { darken as darkenOrigin, lighten as lightenOrigin } from '@material-ui/core'

export const safeDarken = (color, exp = 0.2) => {
  try {
    return darkenOrigin(color, exp)
  } catch (error) {
    return color
  }
}
export const safeLighten = (color, exp = 0.2) => {
  try {
    return lightenOrigin(color, exp)
  } catch (error) {
    return color
  }
}

export const lighten = safeLighten

// adapted from
// http://jsfiddle.net/Mottie/xcqpF/1/light/
const rgb2hex = (rgb) => {
  return rgb && rgb.length === 3
    ? '#' +
        ('0' + parseInt(rgb[0], 10).toString(16)).slice(-2) +
        ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
        ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2)
    : ''
}

// next two methods converted from Ruby to JS
// soured from http://martin.ankerl.com/2009/12/09/how-to-create-random-colors-programmatically/

// # HSV values in [0..1[
// # returns [r, g, b] values from 0 to 255
export const hsv_to_rgb = (h, s, v) => {
  const h_i = Math.floor(h * 6)
  const f = h * 6 - h_i
  const p = v * (1 - s)
  const q = v * (1 - f * s)
  const t = v * (1 - (1 - f) * s)
  let r, g, b
  switch (h_i) {
    case 0:
      ;[r, g, b] = [v, t, p]
      break
    case 1:
      ;[r, g, b] = [q, v, p]
      break
    case 2:
      ;[r, g, b] = [p, v, t]
      break
    case 3:
      ;[r, g, b] = [p, q, v]
      break
    case 4:
      ;[r, g, b] = [t, p, v]
      break
    case 5:
      ;[r, g, b] = [v, p, q]
      break
  }
  return [Math.floor(r * 256), Math.floor(g * 256), Math.floor(b * 256)]
}

let preparedListOfColors = [
  '#0c5e5d',
  '#6b5abb',
  '#da4724',
  '#da1793',
  '#8b9a2e',
  '#6014a1',
  '#bcd2e5',
  '#bb6d69',
  '#8bf5f1',
  '#eea31d',
  '#53dd24',
  '#ff0448',
  '#1313bb',
  '#28f6db',
  '#dbf0c4',
  '#c86425',
]
// # use golden ratio
const golden_ratio_conjugate = 0.618033988749895
export const gen_hex = (numberOfColors) => {
  let h = Math.random() // # use random start value
  const colorArray = []
  let index = 0
  while (numberOfColors > 0) {
    if (preparedListOfColors[index]) {
      colorArray.push(preparedListOfColors[index])
    } else {
      h += golden_ratio_conjugate
      h %= 1
      colorArray.push(rgb2hex(hsv_to_rgb(h, 0.5, 0.95)))
    }
    index++
    numberOfColors -= 1
  }
  return colorArray
}

export const predefinedColors = gen_hex(128)

export const getUniqueColor = function (users, index, colors) {
  let uniqueColor = colors[index]
  if (!uniqueColor) {
    let h = Math.random()
    h += golden_ratio_conjugate
    h %= 1
    return rgb2hex(hsv_to_rgb(h, 0.5, 0.95))
  }

  for (let i = 0; i < users.length; i++) {
    if (users[i] && users[i].color == uniqueColor) {
      return getUniqueColor(users, index + 1, colors)
    }
  }

  return uniqueColor
}
